/*
 * 江西消防维保一级路由。
 * 后续维保报告、签到页面统一在此处追加。
 */
import projectRoutes from '@/features/jxxf/wb/project/project.routes.js';
import planRoutes from '@/features/jxxf/wb/plan/plan.routes.js';
import signRoutes from './sign/sign.routes.js';
import reportRoutes from './report/report.routes.js';

export default {
  path: 'wb',
  name: 'jxxfWb',
  component: { template: '<router-view></router-view>' },
  children: [projectRoutes, planRoutes, signRoutes, reportRoutes]
};
